export default "__VITE_ASSET__CkdSH09M__"